import type { SecurityRole } from './model.js';

export const PERMISSIONS = [
  'VIEW_OPERATIONAL',
  'PERFORM_TECHNICIAN_ACTIONS',
  'MANAGE_OPERATIONAL_SETTINGS',
  'REFRESH_BACKUP_DATA',
  'TEST_EMAIL_DELIVERY',
  'ACCESS_PLATFORM_ADMIN',
  'MANAGE_PLATFORM_IDENTITY',
  'MANAGE_CLIENTS',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

const ROLE_PERMISSIONS: Record<SecurityRole, ReadonlySet<Permission>> = {
  OWNER: new Set(PERMISSIONS),
  ADMIN: new Set([
    'VIEW_OPERATIONAL',
    'PERFORM_TECHNICIAN_ACTIONS',
    'MANAGE_OPERATIONAL_SETTINGS',
    'REFRESH_BACKUP_DATA',
    'TEST_EMAIL_DELIVERY',
    'MANAGE_CLIENTS',
  ]),
  OPERATOR: new Set([
    'VIEW_OPERATIONAL',
    'PERFORM_TECHNICIAN_ACTIONS',
  ]),
  VIEWER: new Set(['VIEW_OPERATIONAL']),
};

export function hasRole(
  roles: SecurityRole | readonly SecurityRole[],
  role: SecurityRole,
): boolean {
  return roleList(roles).includes(role);
}

export function can(
  roles: SecurityRole | readonly SecurityRole[],
  permission: Permission,
): boolean {
  return roleList(roles)
    .some((role) => ROLE_PERMISSIONS[role].has(permission));
}

export function canAccessPlatformAdmin(roles: SecurityRole | readonly SecurityRole[]): boolean {
  return can(roles, 'ACCESS_PLATFORM_ADMIN');
}

export function isReadOnly(roles: SecurityRole | readonly SecurityRole[]): boolean {
  return !can(roles, 'PERFORM_TECHNICIAN_ACTIONS');
}

function roleList(roles: SecurityRole | readonly SecurityRole[]): readonly SecurityRole[] {
  return typeof roles === 'string' ? [roles] : roles;
}
